export const skillData = [
	{
		name: "HTML",
		src: "html.svg",
		type: ["All", "Frontend"],
		exp: "2 years",
	},
	{
		name: "CSS",
		src: "css.svg",
		type: ["All", "Frontend"],
		exp: "2 years",
	},
	{
		name: "JavaScript",
		src: "js_official.svg",
		type: ["All", "Frontend"],
		exp: "2 years",
	},
	{
		name: "TypeScript",
		src: "typescript.svg",
		type: ["All", "Frontend",],
	},
	{
		name: "Node",
		src: "node.svg",
		type: ["All", "Backend"],
		exp: "1 year",
	},
	{
		name: "GraphQL",
		src: "graphql.svg",
		type: ["All", "Frontend"],
		exp: "1 years",
	},
	{
		name: "Next.js",
		src: "nextjs.svg",
		type: ["All", "Frontend", "Framework"],
	},
	{
		name: "PostgreSQL",
		src: "postgresql.svg",
		type: ["All", "Backend"],
	},
	{
		name: "Docker",
		src: "docker.svg",
		type: ["All", "Tool"],
	},
	{
		name: "MongoDB",
		src: "mongodb.svg",
		type: ["All", "Backend"],
	},
	{
		name: "Express",
		src: "expressjs.svg",
		type: ["All", "Backend", "Framework"],
		exp: "1 year",
	},
	{
		name: "ReactJS",
		src: "reactjs.svg",
		type: ["All", "Frontend", "Framework", "Library"],
		exp: "2 years",
	},
	{
		name: "Material UI",
		src: "mui.svg",
		type: ["All", "Frontend", "Library"],
		exp: "1 year",
	},
	{
		name: "Sass",
		src: "scss.svg",
		type: ["All", "Frontend", "Library", "Tool"],
		exp: "2 years",
	},
	{
		name: "npm",
		src: "npm.svg",
		type: ["All", "Tool"],
		exp: "2 years",
	},
	{
		name: "Git",
		src: "git.svg",
		type: ["All", "Tool"],
		exp: "2 years",
	},
	{
		name: "Webpack",
		src: "webpack.svg",
		type: ["All", "Tool"],
		exp: "6 months",
	},
];
